"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var forEach_1 = __importDefault(require("lodash/forEach"));
var index_1 = require("../index");
var StringFormat = /** @class */ (function () {
    /**
     *  @param locale Languages that need to be localized
     *  @param locale Data dictionary, ICU grammar
     */
    function StringFormat(locale, lang) {
        this.locale = locale;
        this.lang = lang;
    }
    /**
     * Produce the formatted string for displaying to the user
     * @param des {id: string, defaultString: string }
     * @param variables {[propName: string]: string}
     * @param options {FormatOptions}
     */
    StringFormat.prototype.format = function (des, variables, options) {
        var _this = this;
        var hasVariables = variables && Object.keys(variables).length > 0;
        var lang = options.lang;
        var formattedMessage;
        var defaultString = des.defaultMessage || des.defaultString || '';
        try {
            var message_1 = this.locale[lang] && this.locale[lang][des.id] ? this.locale[lang][des.id] : '';
            // 根据语种寻找 fallback的语种的翻译
            if (!message_1 && window.__PANDA.langList) {
                window.__PANDA.langList.find(function (_lang) {
                    if (_this.locale[_lang] && _this.locale[_lang][des.id]) {
                        message_1 = _this.locale[_lang][des.id];
                        return true;
                    }
                    return false;
                });
            }
            // 需要确保使用正确的message，没语言包使用dm
            message_1 = message_1 || defaultString;
            if (hasVariables) {
                var parsedMessage_1 = message_1;
                (0, forEach_1.default)(variables, function (v, k) {
                    var reg = new RegExp("{".concat(k, "}"), 'g');
                    // v 为 string | number , 但是有 value 是 null / undefined 的风险
                    var value = typeof v === 'object' || typeof v === 'undefined' ? '' : v.toString();
                    parsedMessage_1 = parsedMessage_1.replace(reg, value);
                });
                formattedMessage = parsedMessage_1;
            }
            else {
                formattedMessage = message_1;
            }
        }
        catch (e) {
            var errorMessage = typeof e === 'string' ? e : 'Unknown error';
            (0, index_1.error)("".concat(des.id, " for ").concat(lang, " failed: \n").concat(errorMessage));
            (0, index_1.debugError)(e);
        }
        return formattedMessage || defaultString || des.id || '';
    };
    StringFormat.prototype.setLocale = function (locale) {
        this.locale = locale;
    };
    return StringFormat;
}());
exports.default = StringFormat;
